import useWidth from '../Hooks/useWidth';
import DialogWrapper from './components/DialogWrapper/DialogWrapper';
import PopoverWrapper from './components/PopoverWrapper/PopoverWrapper';
import { PopoverOrDialogInMobileWrapperProps } from './popoverOrDialogInMobileWrapper.types';

const PopoverOrDialogInMobileWrapper = ({
  anchorEl,
  children,
  isOpen,
  onClose,
  popoverOrigin,
  transitionComponent,
  transitionProps,
  disableScrollLock,
  testId,
}: PopoverOrDialogInMobileWrapperProps) => {
  const { mobileWidth } = useWidth();

  if (mobileWidth) {
    return (
      <DialogWrapper testId={testId} isOpen={isOpen}>
        {children}
      </DialogWrapper>
    );
  }

  return (
    <PopoverWrapper
      test-id={testId}
      isOpen={isOpen}
      onClose={onClose}
      anchorEl={anchorEl}
      popoverOrigin={popoverOrigin}
      transitionProps={transitionProps}
      disableScrollLock={disableScrollLock}
      transitionComponent={transitionComponent}
    >
      {children}
    </PopoverWrapper>
  );
};

export default PopoverOrDialogInMobileWrapper;
